export default __webpack_public_path__ + "poster_right_slider.png";